/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../../redux/Reducer";
import ActionCard from "./actionCard";
import { GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS } from "../../../../redux/Action/actionTypes";

const FinalizationOverview = ({ currentStep, isEditDisabled }: { currentStep: number, isEditDisabled: boolean }) => {
  const [finalizationActionCards, setFinalizationActionCards] = useState<
    object[]
  >([]);
  const negotiationContractData = useSelector(
    (state: RootState) => state.dashboardData.detailedOverviewData
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (Object.keys(negotiationContractData).length > 0) {
      let finalizationArr: any = [];
      negotiationContractData.planNegotiationActions.negotiationRoundsDetails
        .length &&
        negotiationContractData.planNegotiationActions.negotiationRoundsDetails.map(
          (data: any) => {
            if (data.roundName === "Finalization") {
              finalizationArr = data.selectedAction;
            }
          }
        );
      setFinalizationActionCards(finalizationArr);
    }
  }, [negotiationContractData, currentStep]);

  const handleCheckboxChange = (id: string) => {
    setFinalizationActionCards((prevCardArr) =>
      prevCardArr.map((item: any) =>
        item.id === id
          ? { ...item, isNegotiationActionUsed: !item.isNegotiationActionUsed }
          : item
      )
    );
    negotiationContractData.planNegotiationActions.negotiationRoundsDetails
      .length &&
      negotiationContractData.planNegotiationActions.negotiationRoundsDetails.map(
        (data: any) => {
          if (data.roundName === "Finalization") {
            let newArr: any = [];
            newArr =
              data.selectedAction.length &&
              data.selectedAction.map((item: any) =>
                item.id === id
                  ? {
                    ...item,
                    isNegotiationActionUsed: !item.isNegotiationActionUsed,
                  }
                  : item
              );
            data.selectedAction = newArr;
          }
        }
      );
    dispatch({
      type: GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS,
      payload: negotiationContractData,
    });
  };

 const handleInputChange = (cardId: string, value: string) => {
     const updatedCards = finalizationActionCards.map((item: any) =>
       item.id === cardId ? { ...item, implementationApproach: value } : item
     );
     setFinalizationActionCards(updatedCards);
     const updatedData = { ...negotiationContractData };
     updatedData.planNegotiationActions.negotiationRoundsDetails = updatedData.planNegotiationActions.negotiationRoundsDetails.map(
       (round: any) =>
         round.roundName === "Finalization"
           ? {
               ...round,
               selectedAction: round.selectedAction.map((item: any) =>
                 item.id === cardId
                   ? { ...item, implementationApproach: value }
                   : item
               ),
             }
           : round
     );
     dispatch({
       type: GET_DETAILED_NEGOTIATION_OVERVIEW_SUCCESS,
       payload: updatedData,
     });
   };

  return (
    <div className="finalization-actions-overview">
      <div className="finalization-actions-overview-heading">
        Finalization actions:
      </div>
      <div className="row">
        {finalizationActionCards.length > 0 ? (
          finalizationActionCards.map((data: any, index: number) => {
            return (
              <ActionCard
                key={data.id}
                contractData={data}
                handleCheckboxChange={handleCheckboxChange}
                onInputChange={(value) => handleInputChange(data.id, value)}
                isEditDisabled={isEditDisabled}
              />
            );
          })
        ) : (
          <div className="negotiation-no-data-message">
            Plan Negotiation Actions are not available.
          </div>
        )}
      </div>
    </div>
  );
};

export default FinalizationOverview;
